import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { Model } from '../core';
import { SphereGeometry } from '../geometry';
import { uid } from '../utils';

var Sphere =
/*#__PURE__*/
function (_Model) {
  _inherits(Sphere, _Model);

  function Sphere(gl) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Sphere);

    var _opts$id = opts.id,
        id = _opts$id === void 0 ? uid('sphere') : _opts$id;
    return _possibleConstructorReturn(this, _getPrototypeOf(Sphere).call(this, gl, Object.assign({}, opts, {
      id: id,
      geometry: new SphereGeometry(opts)
    })));
  }

  return Sphere;
}(Model);

export { Sphere as default };
//# sourceMappingURL=sphere.js.map


//////////////////
// WEBPACK FOOTER
// ./~/luma.gl/dist/esm/models/sphere.js
// module id = 635
// module chunks = 0